import React, {Component, Fragment} from "react";
import {Card, CardBody, Col, Row} from "reactstrap";
import TransactionStatus from "../domain/Transaction/TransactionStatus";
import QuotationRequestService from "../services/Transaction/QuotationRequestService";
import SFXLoadingComponent from "./SFXLoadingComponent";
import TransactionService from "../services/Transaction/TransactionService";


const DECLARATION_LINK = process.env.REACT_APP_DECLARATION_LINK;
const HOW_TO_PAY_LINK = process.env.REACT_APP_HOW_TO_PAY_LINK;
const T_AND_C_LINK = process.env.REACT_APP_T_AND_C_LINK;

export default class TransactionCompleteCard extends Component {

    constructor(props) {
        super(props);

        this.transactionId = this.props.transaction.transactionId;

        this.state = {
            transaction: null,
            quotationRequest: null,
            loading: true
        }
    }

    componentDidMount() {

        if (this.props.setHeader)
            this.props.setHeader();

        let promiseArr = [];

        promiseArr.push(TransactionService.retrieveTransactionByTransactionId(this.transactionId));
        promiseArr.push(QuotationRequestService.retrieveQuotationRequestByTransactionId(this.transactionId));

        Promise.all(promiseArr).then(response => {
            this.setState({
                transaction: response[0],
                quotationRequest: response[1],
                loading: false
            })
        })
    }

    render() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>
            {this.props.className === 'mobile' ? this.renderTransactionCards("mobile") : this.renderBrowserTransactionCards("browser")}
        </Fragment>
    }

    renderBrowserTransactionCards(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto",
            height: "auto"
        }}>
            {this.renderTransactionCards(className)}
        </Card>
    }

    renderTransactionCards(className) {
        return <Fragment>
            <CardBody>
                <div style={{
                    padding: "4px 8px",
                    display: "flex",
                    margin: "auto",
                    width: "100%",
                    fontSize: "11pt"
                }}>
                    {this.renderHeader()}
                </div>
                <div style={{
                    padding: "8px",
                    display: "flex-box",
                    margin: "auto",
                    width: "100%",
                    fontSize: "10pt"
                }}>
                    {this.renderBody()}
                </div>
                <div style={{
                    padding: "8px",
                    display: "flex-box",
                    margin: "auto",
                    width: "100%",
                    fontSize: "10pt"
                }}>
                    {this.renderBodyInformation()}
                </div>
            </CardBody>
        </Fragment>
    }

    renderHeader() {
        return <Fragment>
            <div style={{display: "flex", margin: "auto"}}>
                <div style={{
                    marginRight: "15px",
                    minWidth: "60px",
                    minHeight: "60px",
                    margin: "auto",
                    paddingTop: "5px"
                }}>
                <span className={"flag-icon flag-icon-" + this.state.transaction.beneficiaryCountryISO2}
                      style={{flex: "1", borderRadius: "30%", minWidth: "45px", minHeight: "45px"}}/>
                </div>
                <div style={{flex: "2", maxWidth: "100%", margin: "auto"}}>
                    {this.state.transaction.beneficiaryFullName}
                </div>
            </div>
            <div style={{flex: "1", textAlign: "right", margin: "auto"}}>
                {TransactionStatus.getStatus(this.state.transaction.status)}
            </div>
        </Fragment>
    }

    renderBody() {
        return <Fragment>
            <div style={{
                fontSize: "8pt",
                textAlign: "center",
                color: "gray",
                paddingBottom: "4px"
            }}>{this.state.transaction.displayDate}</div>
            <div style={{
                textAlign: "center",
                display: "flex",
                backgroundColor: "lightgray",
                padding: "4px 0px"
            }}>
                <div style={{
                    maxWidth: "50%",
                    flex: "1",
                    textAlign: "center",
                    color: "black",
                    borderRight: "1px #00A6FF solid"
                }}>R {this.state.transaction.total}</div>
                <div style={{
                    maxWidth: "50%",
                    flex: "1",
                    textAlign: "center",
                    color: "green",
                    borderLeft: "1px #00A6FF solid"
                }}>{this.state.transaction.destinationCurrency} {this.state.transaction.destinationAmount}</div>
            </div>
        </Fragment>
    }

    renderLabelValue(label, value) {
        return <Row style={{fontSize: "14px"}}><span style={{fontWeight: "bold"}}>{label} </span> {value}
        </Row>
    }

    renderBodyInformation() {

        return <Fragment>

            <Row>
                <Col>
                    <Row className={"mobile_quote_display_row"} style={{paddingLeft: "15px"}}>
                        <Col>
                            {this.renderLabelValue("Payout Method: ", this.state.quotationRequest.payoutMethod)}
                            {this.renderLabelValue("Payout Partner: ", this.state.quotationRequest.payoutPartnerName)}
                            {this.renderLabelValue("Fees: ", this.state.transaction.fees)}
                            {this.renderLabelValue("VAT: ", this.state.transaction.vat)}
                        </Col>
                    </Row>

                    <Row style={{paddingLeft: "15px"}}>
                        <Col>
                            <Row>
                                <a href={DECLARATION_LINK} className={"transaction_complete_links"}
                                   target="_blank" rel="noopener noreferrer">Declaration</a>
                            </Row>
                            <Row>
                                <a href={HOW_TO_PAY_LINK} className={"transaction_complete_links"} target="_blank"
                                   rel="noopener noreferrer">How
                                    to Pay</a>
                            </Row>
                            <Row>
                                <a href={T_AND_C_LINK} className={"transaction_complete_links"} target="_blank"
                                   rel="noopener noreferrer">Terms
                                    & Conditions</a>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>

        </Fragment>
    }
}